import { signup } from '../../../../../common';
import * as lib from '#glib/data/core/api';
import qs from 'query-string';

// Connect timeout
const CONNECT_TIMEOUT = 2000;

/**
 * Api
 */
export class Api extends lib.Api {

	/**
	 * Class constructor
	 */
	public constructor() {
		super({
			autoConnect: false,
			connectTimeout: CONNECT_TIMEOUT,
            autoReconnect: true,
		})
	}	

	/**
	 * Submit SignUp request
	 * @param data 
	 * @returns 
	 */
	public async submit(data: signup.IData): Promise<{ message: string; error: string; redirect: string } | void> {

		try {
			console.log('Submitting >>>', data);

			const res = await this.asyncRequests.add(this.fetch('/signup/submit', {
				method: 'POST',
				cache: 'no-cache',
				mode: 'cors',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ ...data, nonce: qs.parse(location.search).nonce }),
			}));
	
			const jres: { message: string; error: string; redirect: string } = await res.json();

			console.log('Submit res. <<<', jres);

			return jres;
		}
		catch(err) {
			err instanceof Error && this.errors.setError(err);
			console.error(err);
			return void 0;
		}

	}

	/**
	 * Go to ext auth
	 */
	public goToExtAuth = async (url: string) => {

		console.log('goToExtAuth >>>', url);

		const res = await this.fetch(url, {
			method: 'POST',
			cache: 'no-cache',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				redirect: '/signup',
				params: qs.parse(location.search),
			}),
		})

		const jres: { url: string } = await res.json();

		location.assign(jres.url);
	}
}